exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".video-frame {\n    width: 100%;\n    height: 480px;\n    /*width: 560px;*/\n    /*height: 315px;*/\n    margin: 0 auto;\n    margin-bottom: 40px;\n    padding: 20px;\n}\n\n.instruction-landing {\n    margin: 0 !important;\n    padding: 10%;\n    padding-top: 100px;\n}\n\n.scroll-bar {\n    overflow: auto;\n    max-height: 640px;\n}\n\n.right{\n    text-align: left;\n}\n\n.picture-size{\n    width: 40%;\n    height: 40%\n}\n\n.picture-size-checkout{\n    width: 20%;\n    height: 20%\n}\n\n.picture-size-confirm{\n    width: 15%;\n    height: 15%\n}\n.picture-size-menu-item{\n    width: 10%;\n    height: 10%\n}\n\n.picture-size-menu-item-small{\n    width: 6%;\n    height: 6%\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/css/instructions.component.css
// module id = ../../../../../src/app/css/instructions.component.css
// module chunks = main